function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "36.987"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4975",
  "data-name": "Group 4975",
  transform: "translate(-2239.508 -1865.434)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2739",
  "data-name": "Path 2739",
  d: "M13.317 133.059h-2.575v-2.575h2.575zm3-5.575H7.742v8.575h8.575z",
  transform: "translate(2231.766 1738.156)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2740",
  "data-name": "Path 2740",
  d: "M44.248 132.852h-2.575v-2.575h2.575zm3-5.574h-8.575v8.575h8.575z",
  transform: "translate(2231.766 1738.156)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2741",
  "data-name": "Path 2741",
  d: "M44.742 157.2h-2.575v-2.575h2.575zm3-5.575h-8.575v8.575h8.575z",
  transform: "translate(2231.766 1738.156)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2742",
  "data-name": "Path 2742",
  d: "M28.672 145.073H26.1V142.5h2.575zm3-5.575H23.1v8.575h8.575z",
  transform: "translate(2231.766 1738.156)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2743",
  "data-name": "Path 2743",
  d: "M13.317 161.265h-2.575v-2.575h2.575zm3-5.575H7.742v8.575h8.575z",
  transform: "translate(2231.766 1738.156)"
}))));